import { IUser } from 'src/@types';
import * as constants from './constants';
import { UserAction } from './action';

export interface IUserState {
  user: IUser;
}

export const initialState: IUserState = {
  user: {
    email: '',
    password: '',
    roleId: 1,
    createdDate: new Date(),
    updatedDate: new Date()
  }
};

export const reducer = (
  state: IUserState = initialState,
  action: UserAction
): IUserState => {
  switch (action.type) {
    case constants.UPDATE_USER:
      return {
        ...state,
        user: {
          ...action.payload,
          createdDate: new Date(action.payload.createdDate),
          updatedDate: new Date(action.payload.updatedDate)
        }
      };
    case constants.CLEAR_USER:
      return {
        ...state,
        user: initialState.user
      };
    /* istanbul ignore next */
    default:
      return {
        ...state
      };
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/reducer.ts